(function () {
  if (window.innerWidth > 749) return;

  window.addEventListener('resize', function () {
    if (window.innerWidth > 749) closeDrawer(true);
  });

  /* ── Backdrop ── */
  const backdrop = document.createElement('div');
  backdrop.id = 'bm-backdrop';
  document.body.appendChild(backdrop);

  /* ── Drawer shell ── */
  const drawer = document.createElement('div');
  drawer.id = 'bm-mobile-drawer';

  const closeBtn = document.createElement('button');
  closeBtn.id = 'bm-close-btn';
  closeBtn.setAttribute('aria-label', 'Close menu');
  closeBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none"><line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';

  const drawerContent = document.createElement('div');
  drawerContent.id = 'bm-drawer-content';

  const socialContainer = document.createElement('div');
  socialContainer.id = 'bm-social-icons';

  drawer.appendChild(closeBtn);
  drawer.appendChild(drawerContent);
  drawer.appendChild(socialContainer);
  document.body.appendChild(drawer);

  const TREAT_BAR_IMAGE = '/cdn/shop/t/17/assets/bm-treat-bar-image.png';

  /* ── NUCLEAR OPTION: Override header-drawer custom element ── */
  function disableSenseDrawer() {
    if (customElements.get('header-drawer')) {
      const headerDrawers = document.querySelectorAll('header-drawer');
      headerDrawers.forEach(function (el) {
        const clone = el.cloneNode(true);
        el.parentNode.replaceChild(clone, el);
      });
    }

    const obs = new MutationObserver(function () {
      document.querySelectorAll('header-drawer:not([data-bm-disabled])').forEach(function (el) {
        el.setAttribute('data-bm-disabled', 'true');
        const fresh = el.cloneNode(true);
        el.parentNode.replaceChild(fresh, el);
      });
    });
    obs.observe(document.body, { childList: true, subtree: true });

    function lockDetails() {
      const detailsEl = document.getElementById('Details-menu-drawer-container');
      if (!detailsEl || detailsEl.dataset.bmLocked) return;
      detailsEl.dataset.bmLocked = 'true';
      new MutationObserver(function () {
        if (detailsEl.hasAttribute('open')) {
          detailsEl.removeAttribute('open');
        }
      }).observe(detailsEl, { attributes: true, attributeFilter: ['open'] });
    }

    lockDetails();
    setTimeout(lockDetails, 500);
    setTimeout(lockDetails, 1500);
  }

  /* ── Place a transparent button ON TOP of the hamburger ── */
  function placeHamburgerTrap() {
    const hamburger = document.querySelector('details#Details-menu-drawer-container > summary');
    if (!hamburger) return false;

    const rect = hamburger.getBoundingClientRect();
    if (rect.width === 0) return false;

    let trap = document.getElementById('bm-hamburger-trap');
    if (!trap) {
      trap = document.createElement('button');
      trap.id = 'bm-hamburger-trap';
      trap.setAttribute('aria-label', 'Open menu');
      trap.style.cssText = [
        'position:fixed',
        'z-index:99999',
        'background:transparent',
        'border:none',
        'cursor:pointer',
        'padding:0',
        'margin:0'
      ].join(';');
      trap.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        openDrawer();
      });
      document.body.appendChild(trap);
    }

    trap.style.top = rect.top + 'px';
    trap.style.left = rect.left + 'px';
    trap.style.width = rect.width + 'px';
    trap.style.height = rect.height + 'px';

    return true;
  }

  /* ── Build nav data ── */
  function buildNavData() {
    const sourceMenu = document.querySelector('#Details-menu-drawer-container .menu-drawer__menu.has-submenu');
    if (!sourceMenu) return [];
    const items = [];
    sourceMenu.querySelectorAll(':scope > li').forEach(function (li) {
      const details = li.querySelector(':scope > details');
      if (details) {
        const summary = details.querySelector(':scope > summary');
        const title = summary ? summary.childNodes[0].textContent.trim() : '';
        const children = [];
        const childUl = details.querySelector('.menu-drawer__submenu .menu-drawer__menu');
        if (childUl) {
          childUl.querySelectorAll(':scope > li').forEach(function (childLi) {
            const childDetails = childLi.querySelector(':scope > details');
            if (childDetails) {
              const childSummary = childDetails.querySelector(':scope > summary');
              const childTitle = childSummary ? childSummary.childNodes[0].textContent.trim() : '';
              const grandchildren = [];
              const grandUl = childDetails.querySelector('.menu-drawer__submenu .menu-drawer__menu');
              if (grandUl) {
                grandUl.querySelectorAll('a').forEach(function (a) {
                  grandchildren.push({ title: a.textContent.trim(), url: a.href, image: null });
                });
              }
              children.push({ title: childTitle, children: grandchildren });
            } else {
              const a = childLi.querySelector('a');
              if (a) children.push({ title: a.textContent.trim(), url: a.href, image: null, children: [] });
            }
          });
        }
        items.push({ title: title, children: children, isTreatBar: title.toUpperCase().includes('TREAT') });
      } else {
        const a = li.querySelector('a');
        if (a) items.push({ title: a.textContent.trim(), url: a.href, children: [] });
      }
    });
    return items;
  }

  /* ── Build social icons ── */
  function buildSocialIcons() {
    const sourceList = document.querySelector('#Details-menu-drawer-container .list-social');
    socialContainer.innerHTML = '';

    const loginLink = document.createElement('a');
    loginLink.href = '/customer_authentication/redirect?locale=en&region_country=IN';
    loginLink.className = 'bm-login-link';
    loginLink.innerHTML = `<img src="/cdn/shop/t/17/assets/icon-account-user.svg" width="28" height="28" alt="Account"><span style="padding-top:10px;">Log In</span>`;
    loginLink.addEventListener('click', function(e) {
      e.stopPropagation();
      window.location.href = '/customer_authentication/redirect?locale=en&region_country=IN';
    });
    socialContainer.appendChild(loginLink);

    const spacer = document.createElement('div');
    spacer.style.flex = '1';
    socialContainer.appendChild(spacer);

    if (sourceList) {
      const socialGroup = document.createElement('div');
      socialGroup.style.cssText = 'display:flex;align-items:center;gap:4px;';
      sourceList.querySelectorAll('a').forEach(function (a) {
        const clone = a.cloneNode(true);
        clone.classList.remove('list-social__link', 'link');
        const svg = clone.querySelector('svg');
        if (svg) {
          svg.setAttribute('width', '40');
          svg.setAttribute('height', '40');
        }
        socialGroup.appendChild(clone);
      });
      socialContainer.appendChild(socialGroup);
    }
  }

  /* ── Render panel ── */
  function renderPanel(items, parentTitle, level, showImage) {
    const panel = document.createElement('div');
    panel.className = 'bm-nav-panel bm-active-panel';
    let html = '';

    if (parentTitle) {
      html += `<button class="bm-back-btn">
        <svg viewBox="0 0 24 24" fill="none"><polyline points="15 18 9 12 15 6" stroke="#1a1a1a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        ${parentTitle}
      </button>`;
    }

    html += '<ul class="bm-nav-list">';
    items.forEach(function (item, i) {
      if (item.children && item.children.length > 0) {
        html += `<li class="bm-nav-item" style="--item-index:${i}">
          <button class="bm-nav-trigger" data-index="${i}">
            ${item.title}
            <span class="bm-nav-arrow">
              <svg viewBox="0 0 24 24" fill="none"><polyline points="9 18 15 12 9 6" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </span>
          </button>
        </li>`;
      } else {
        const thumb = item.image ? `<img class="bm-nav-thumb" src="${item.image}" alt="${item.title}" width="36" height="36">` : '';
        html += `<li class="bm-nav-item" style="--item-index:${i}">
          <a href="${item.url || '#'}" class="bm-nav-link${item.image ? ' bm-has-image' : ''}">
            ${thumb}${item.title}
          </a>
        </li>`;
      }
    });
    html += '</ul>';

    panel.innerHTML = html;

    const backBtn = panel.querySelector('.bm-back-btn');
    if (backBtn) backBtn.addEventListener('click', goBack);

    panel.querySelectorAll('.bm-nav-trigger').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const item = items[parseInt(btn.dataset.index)];
        if (item && item.children) drillInto(item.children, item.title, level + 1, item.isTreatBar || false);
      });
    });

    return panel;
  }

  /* ── Helper: remove treat bar image ── */
  function removeTreatBarImage() {
    const existing = drawer.querySelector('.bm-submenu-image-wrap');
    if (existing) existing.remove();
  }

  /* ── Panel stack ── */
  const panelStack = [];

  function drillInto(items, title, level, showImage) {
    const current = drawerContent.querySelector('.bm-nav-panel.bm-active-panel');
    if (current) { current.classList.remove('bm-active-panel'); current.style.display = 'none'; }

    const panel = renderPanel(items, title, level, false);
    drawerContent.appendChild(panel);
    panelStack.push(panel);

    removeTreatBarImage();
    if (showImage) {
      drawer.classList.add('bm-treat-bar-active');
      const imgWrap = document.createElement('div');
      imgWrap.className = 'bm-submenu-image-wrap';
      imgWrap.innerHTML = `<img src="${TREAT_BAR_IMAGE}" alt="Treat Bar" onerror="this.parentElement.style.display='none'">`;
      drawer.appendChild(imgWrap);
    } else {
      drawer.classList.remove('bm-treat-bar-active');
    }

    panel.classList.add('bm-slide-from-right');
    setTimeout(function () { panel.classList.remove('bm-slide-from-right'); }, 300);
    triggerStagger(panel);
  }

  function goBack() {
    drawer.classList.remove('bm-treat-bar-active');
    removeTreatBarImage();

    const current = panelStack[panelStack.length - 1];
    if (current) current.style.animation = 'bmSlideOutToRight 0.22s cubic-bezier(0.32,0.72,0,1) forwards';

    setTimeout(function () {
      const done = panelStack.pop();
      if (done) drawerContent.removeChild(done);
      const prev = panelStack[panelStack.length - 1];
      if (prev) {
        prev.style.display = '';
        prev.classList.add('bm-active-panel', 'bm-slide-from-left');
        triggerStagger(prev);
        setTimeout(function () { prev.classList.remove('bm-slide-from-left'); }, 300);
      }
    }, 220);
  }

  function triggerStagger(panel) {
    panel.querySelectorAll('.bm-nav-item').forEach(function (el) {
      el.style.animation = 'none';
      el.offsetHeight;
      el.style.animation = '';
    });
  }

  /* ── Open ── */
  function openDrawer() {
    drawerContent.innerHTML = '';
    panelStack.length = 0;
    removeTreatBarImage();
    drawer.classList.remove('bm-treat-bar-active');

    const navData = buildNavData();
    const panel = renderPanel(navData, null, 0, false);
    drawerContent.appendChild(panel);
    panelStack.push(panel);
    buildSocialIcons();

    backdrop.classList.add('bm-visible');
    requestAnimationFrame(function () {
      backdrop.classList.add('bm-active');
      drawer.classList.add('bm-open');
      document.body.classList.add('bm-page-pushed');
    });
    document.body.style.overflow = 'hidden';
    document.body.classList.add('bm-drawer-open');

    document.querySelectorAll('body > *:not(#bm-mobile-drawer):not(#bm-backdrop)').forEach(function (el) {
      const s = window.getComputedStyle(el);
      if (s.position === 'fixed' || s.position === 'sticky') {
        if (el.classList.contains('klaviyo-form') || el.id.toLowerCase().includes('popup') || el.getAttribute('data-testid')?.includes('popup')) return;
        el.dataset.bmOriginalZ = el.style.zIndex;
        el.style.setProperty('z-index', '100', 'important');
        el.style.setProperty('pointer-events', 'none', 'important');
      }
    });

    /* FIX 2: exclude ecomsend modal and all its children */
    document.querySelectorAll('[class*="ecomsend"]').forEach(function (el) {
      // if (el.closest('.ecomsend__Modal__Container')) return;
      el.dataset.bmOriginalZ = el.style.zIndex;
      el.style.setProperty('z-index', '100', 'important');
      el.style.setProperty('pointer-events', 'none', 'important');
    });

    closeBtn.style.display = 'flex';

    const trap = document.getElementById('bm-hamburger-trap');
    if (trap) trap.style.display = 'none';
  }

  /* ── Close ── */
  function closeDrawer(instant) {
    drawer.classList.remove('bm-open', 'bm-treat-bar-active');
    removeTreatBarImage();
    document.body.classList.remove('bm-page-pushed', 'bm-drawer-open');
    document.body.style.overflow = '';

    /* FIX 3: hide drawer content on desktop to prevent links showing */
    if (window.innerWidth > 749) {
      drawerContent.innerHTML = '';
      if (window.innerWidth > 749) {
        drawerContent.innerHTML = '';
        panelStack.length = 0;
        socialContainer.innerHTML = '';  // ADD THIS
      }
      panelStack.length = 0;
    }

    document.querySelectorAll('body > *:not(#bm-mobile-drawer):not(#bm-backdrop)').forEach(function (el) {
      if (el.dataset.bmOriginalZ !== undefined) {
        el.style.zIndex = el.dataset.bmOriginalZ;
        el.style.removeProperty('pointer-events');
        delete el.dataset.bmOriginalZ;
      }
    });
    document.querySelectorAll('[class*="ecomsend"]').forEach(function (el) {
      if (el.dataset.bmOriginalZ !== undefined) {
        el.style.zIndex = el.dataset.bmOriginalZ;
        el.style.removeProperty('pointer-events');
        delete el.dataset.bmOriginalZ;
      }
    });

    /* FIX 1 (backdrop): remove bm-active first, then bm-visible after transition */
    backdrop.classList.remove('bm-active');
    setTimeout(function () { backdrop.classList.remove('bm-visible'); }, instant ? 0 : 350);

    closeBtn.style.display = 'none';

    const trap = document.getElementById('bm-hamburger-trap');
    if (trap) trap.style.display = '';
  }

  /* ── Init sequence ── */
  /* FIX 1 (hamburger): always run all retries, never return early */
  function init() {
    disableSenseDrawer();
    placeHamburgerTrap();
    setTimeout(function() { placeHamburgerTrap(); }, 100);
    setTimeout(function() { placeHamburgerTrap(); }, 300);
    setTimeout(function() { placeHamburgerTrap(); }, 600);
    setTimeout(function() { placeHamburgerTrap(); }, 1000);
    setTimeout(function() { placeHamburgerTrap(); }, 1500);
  }

  closeBtn.style.display = 'none';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  closeBtn.addEventListener('click', function () { closeDrawer(false); });
  backdrop.addEventListener('click', function () { closeDrawer(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(false); });

  /* ── Reposition trap on scroll ── */
  window.addEventListener('scroll', function() {
    if (document.body.classList.contains('bm-drawer-open')) return;
    const trap = document.getElementById('bm-hamburger-trap');
    if (!trap) return;
    const hamburger = document.querySelector('details#Details-menu-drawer-container > summary');
    if (!hamburger) return;
    const rect = hamburger.getBoundingClientRect();
    if (rect.width === 0) return;
    trap.style.top = rect.top + 'px';
    trap.style.left = rect.left + 'px';
    trap.style.width = rect.width + 'px';
    trap.style.height = rect.height + 'px';
  }, { passive: true });

})();
